export const setCategories = (data) => {
    return (dispatch) => {
        dispatch({
            type: "SET_CATEGORIES",
            payload: data
        });
    };
};
